// USA
export const locale = {
	lang: "en",
	data: {
		TRANSLATOR: {
			SELECT: "Select your language"
		},
		MENU: {
			NEW: "new",
			ACTIONS: "Actions",
			CREATE_POST: "Create New Post",
			REPORTS: "Reports",
			APPS: "Apps",
			DASHBOARD: "Dashboard"
		},
		UEX: {
			POLICY: {
				LIST: "Policy list",
				ADD: "New policy",
				UPLOAD_POLICY_DOCUMENT: "Upload Document",
				DRAG_FILES: "Please upload your document"
			},
			COMPANY: {
				LIST: "Company list",
				ADD: "New company"
			},
			MOVEMENT: {
				LIST: "Movement list",
				ADD: "New movement",
				UPLOAD_SUPPORTING_DOCUMENTS: "Invoices Documents",
				SELECT: "Select",
				DRAG_FILES: "Please upload your invoice(s)"
			},
			SUB_MOVEMENT: {
				LIST: "Staff movement list for movement id : {{id}}",
				ADD: "New staff movement"
			},
			INSURED: {
				LIST: "Insured list",
				ADD: "New insured"
			}
		},
		AUTH: {
			GENERAL: {
				OR: "Or",
				SUBMIT_BUTTON: "Submit",
				NO_ACCOUNT: "Don't have an account?",
				SIGNUP_BUTTON: "Signup",
				FORGOT_BUTTON: "Forgot Password",
				BACK_BUTTON: "Back",
				PRIVACY: "Privacy",
				LEGAL: "Legal",
				CONTACT: "Contact"
			},
			LOGIN: {
				TITLE: "Login Account",
				BUTTON: "Sign In"
			},
			FORGOT: {
				TITLE: "Forgotten Password?",
				DESC: "Enter your email to reset your password"
			},
			REGISTER: {
				TITLE: "Sign Up",
				DESC: "Enter your details to create your account",
				SUCCESS:
					"Your account has been successfuly registered. Please use your registered account to login."
			},
			INPUT: {
				EMAIL: "Email",
				FULLNAME: "Fullname",
				PASSWORD: "Password",
				CONFIRM_PASSWORD: "Confirm Password"
			},
			VALIDATION: {
				INVALID: "{{name}} is not valid",
				REQUIRED: "{{name}} is required",
				MIN_LENGTH: "{{name}} minimum length is {{min}}",
				AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
				NOT_FOUND: "The requested {{name}} is not found",
				INVALID_LOGIN: "The login detail is incorrect"
			}
		},
		COMPANY: {
			COMPANY_LIST: "Company list"
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: "Selected records count: ",
				ALL: "All",
				SUSPENDED: "Suspended",
				ACTIVE: "Active",
				FILTER: "Filter",
				BY_STATUS: "by Status",
				BY_TYPE: "by Type",
				BUSINESS: "Business",
				INDIVIDUAL: "Individual",
				SEARCH: "Search",
				IN_ALL_FIELDS: "in all fields"
			},
			ECOMMERCE: "eCommerce",
			CUSTOMERS: {
				CUSTOMERS: "User",
				CUSTOMERS_LIST: "User list",
				NEW_CUSTOMER: "New Customer",
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: "Customer Delete",
					DESCRIPTION:
						"Are you sure to permanently delete this customer?",
					WAIT_DESCRIPTION: "Customer is deleting...",
					MESSAGE: "Customer has been deleted"
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: "Customers Delete",
					DESCRIPTION:
						"Are you sure to permanently delete selected customers?",
					WAIT_DESCRIPTION: "Customers are deleting...",
					MESSAGE: "Selected customers have been deleted"
				},
				UPDATE_STATUS: {
					TITLE: "Status has been updated for selected customers",
					MESSAGE:
						"Selected customers status have successfully been updated"
				},
				EDIT: {
					UPDATE_MESSAGE: "Customer has been updated",
					ADD_MESSAGE: "Customer has been created"
				}
			}
		},
		GLOBAL: {
			COMPANY: {
				LIST: "Company List",
				NEW_COMPANY: "New Company"
			},
			POLICY: {
				LIST: "Policy List"
			},
			INSURED: {
				LIST: "Insured List"
			}
		}
	}
};
